import React, {useState} from 'react'
import {Dropdown, Input} from '@local/ui/components'
import {defaultCountryCallingCodeOption, phoneCodes} from '@local/utils/phoneCodes'
import {cx} from '@local/utils/cx'
import {PHONE_PATTTERN} from '@local/utils/string'

type PhoneNumberInputProps = {
	onChange: (value: string) => void
	onInvalid: (e: React.FormEvent<HTMLInputElement>) => void
	hasError: boolean
	light?: boolean
}

const PhoneNumberInput = ({onChange, onInvalid, light, hasError}: PhoneNumberInputProps) => {
	const [countryCode, setCountryCode] = useState(defaultCountryCallingCodeOption.value)
	const [phoneNumber, setPhoneNumber] = useState('')
	const [isFocused, setIsFocused] = useState(false)

	const onNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const dial = countryCode
		let local = e.target.value
		if (dial && local.startsWith(dial)) {
			local = local.slice(dial.length)
		}
		setPhoneNumber(local)
		onChange(dial + local)
	}

	const optionsContainerBorder = light ? 'border-black' : isFocused ? 'border-grey-1' : 'border-grey-2'

	return (
		<div className={cx(
			'flex items-center col-span-2 w-full bg-transparent rounded-xxs border border-grey-2 peer-focus-visible:border-grey-1 focus:outline-none duration-300 ease-quart-out transition-colors',
			optionsContainerBorder)}>
			<Dropdown
				id='countryCode'
				name='countryCode'
				defaultValue={defaultCountryCallingCodeOption}
				dropdownClassName={cx(
					'shrink-0 min-w-130 border-b-0 border-t-0 border-l-0 border-r-1 rounded-none',
				)}
				placeholder=''
				options={phoneCodes}
				searchable
				onSelect={(dial: string) => {
					setCountryCode(dial)
					setPhoneNumber('')
					onChange(dial)
				}} />
			<Input
				required
				variant={light ? 'light' : 'dark'}
				type='tel'
				name='phoneNumber'
				label='Phone Number'
				value={phoneNumber}
				onChange={onNumberChange}
				onInvalid={onInvalid}
				hasError={hasError}
				pattern={PHONE_PATTTERN}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				className='h-48 w-full border-none'
				inputClassName='h-full border-none'
				errorClassName='z-10 bg-grey-4'
				labelClassName={light ? 'bg-transparent' : 'bg-grey-4'} />
		</div>
	)
}

export default PhoneNumberInput
